"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LinkBrokenIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.965 4.12l1.526-1.522a2.06 2.06 0 012.906 0c.802.801.802 2.1 0 2.9L11.87 7.02l1.415 1.413 1.526-1.522a4.043 4.043 0 000-5.725 4.062 4.062 0 00-5.736 0L7.55 2.707 8.965 4.12zM4.702 8.378L3.287 6.966 1.188 9.059a4.043 4.043 0 000 5.725 4.062 4.062 0 005.736 0l2.1-2.093-1.416-1.412-2.099 2.093c-.802.8-2.103.8-2.906 0a2.048 2.048 0 010-2.9l2.1-2.094zM2.783 6.3h-1.74a1.044 1.044 0 110-2.086h1.74a1.044 1.044 0 110 2.086zm3.172-2.74a1.044 1.044 0 01-1.781-.737V1.085a1.043 1.043 0 012.087 0v1.738c0 .277-.11.542-.306.738zm7.262 6.217h1.74a1.044 1.044 0 110 2.086h-1.74a1.044 1.044 0 110-2.086zm-3.172 2.704a1.044 1.044 0 011.781.738v1.738a1.043 1.043 0 01-2.087 0v-1.738c0-.277.11-.542.306-.738z"
  })))
});
LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var _default = exports.default = LinkBrokenIcon;